// The field `type` strings Barcode and QR Code are allowed to read their
// value from -- must stay in sync with `allowed_source_field_types` on
// `BarcodeFieldType`/`QRCodeFieldType` (backend). Kept in one place so the
// two field sub-forms don't drift apart from each other.
export const SOURCE_FIELD_REFERENCE_ALLOWED_TYPES = [
  'text',
  'long_text',
  'number',
  'formula',
]
